module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/main-menu/main-menu.component.scss
// module id = ./src/app/main-menu/main-menu.component.scss
// module chunks = main